import React from "react";

const SmallItemHolder = ({
  bgColor = "#4f4f4f",
  textColor = "white",
  item,
  onClicked,
  width,
}) => {
  return (
    <div
      className="textWhite"
      style={{
        fontSize: "13px",
        backgroundColor: bgColor,
        color: textColor,
        padding: "5px",
        borderRadius: ".5rem/.5rem",
        width,
      }}
      onClick={() => {
        if (onClicked) onClicked();
      }}
    >
      {typeof item === "string" ? item : item.shortDescription ?? item.name}
    </div>
  );
};

export default SmallItemHolder;
